import { render, staticRenderFns } from "./statisticalReportCR.vue?vue&type=template&id=bacb4ea8&scoped=true"
import script from "./statisticalReportCR.vue?vue&type=script&lang=js"
export * from "./statisticalReportCR.vue?vue&type=script&lang=js"
import style0 from "./statisticalReportCR.vue?vue&type=style&index=0&id=bacb4ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacb4ea8",
  null
  
)

export default component.exports